import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { PaginationRequest } from './models/pagination/pagination.request.model';
import { RequestHelper } from '@shared/helpers';

@Injectable({ providedIn: 'root' })
export class HostAccApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/host-accs`;
    }

    getHostAccs(req: PaginationRequest): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.get<any>(this.url, { params: options });
    }

    getOptions(req: PaginationRequest, body?: any): Observable<any> {
        const options = RequestHelper.createRequestOption(req);
        return this.httpClient.post<any>(`${this.url}/options`, body || {}, { params: options });
    }

    createHostAcc(hostAcc: any): Observable<any> {
        return this.httpClient.post<any>(this.url, hostAcc);
    }

    updateHostAcc(hostAcc: any): Observable<any> {
        return this.httpClient.put<any>(this.url, hostAcc);
    }
}

